<template>
    <div class="muven-select-wrapper">
        <button type="button" 
            class="btn btn-outline-secondary" 
            :disabled="disabled"
            @click="handleRemoval()" 
            v-if="showRemoveButton && !disabled">
            <fa icon="times" />
        </button>

        <slot name="select" />
    </div>
</template>

<script>
export default {
    name: 'SelectWrappedCmp',
    props: {
        showRemoveButton: {
            type: Boolean,
            default: false,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    methods: {
        handleRemoval() {
            this.$emit('removed')
        },
    },
}
</script>

<style lang="scss" scoped>
.muven-select-wrapper {
    position: relative;
    width: 100%;

    .btn.btn-outline-secondary {
        position: absolute;
        top: 0;
        right: 0;
        height: 40px;
        border-color: var(--border-strong);
        z-index: 3;
        background-color: var(--surface-1);
        color: var(--text-muted);

        &:hover {
            color: var(--text-muted);
        }
    }
}
</style>